import { Link } from '@mui/material';
import { useRecoilValue } from 'recoil';
import useWindowLevel from '~/hooks/useWindowLevel';
import {
    defaultWindowLevelState,
} from '~/state/atoms/toolsAtoms';

const ResetWindowingLevelButton = () => {
    const defaultWindowLevel = useRecoilValue(defaultWindowLevelState);
    const { setWindowLevel } = useWindowLevel();

    const resetWindowLevel = () => {
        if (defaultWindowLevel) {
            setWindowLevel(defaultWindowLevel);
        }
    };

    return (
        <Link
            component="button"
            variant="body2"
            value="reset-view"
            underline="none"
            fontSize={12}
            onClick={() => {
                resetWindowLevel();
            }}
            sx={{
                lineHeight: 1,
                padding: 0,
            }}
        >
            RESET
        </Link>
    );
};

export default ResetWindowingLevelButton;
